import { GrammarCategory } from '../../../../types/types';

export const grammaire: GrammarCategory = {

  // ============================================================
  // UNITÉ 1 — PRONOMS & STRUCTURE
  // ============================================================

  'Pronoms sujets': {
    'N': {
      translation: "Je",
      translationEn: "I",
      explanation: "Pronom sujet 1re personne du singulier. En bambara, le pronom sujet se place toujours avant la particule verbale.",
      explanationEn: "Subject pronoun, 1st person singular. In Bambara, the subject pronoun is always placed before the verbal particle.",
      example: "N bɛ taa. (Je vais.)",
      exampleEn: "N bɛ taa. (I am going.)",
      audio: "Ba-n"
    },
    'I': {
      translation: "Tu",
      translationEn: "You (singular)",
      explanation: "Pronom sujet 2e personne du singulier.",
      explanationEn: "Subject pronoun, 2nd person singular.",
      example: "I bɛ kalan. (Tu étudies.)",
      exampleEn: "I bɛ kalan. (You are studying.)",
      audio: "Ba-i"
    },
    'A': {
      translation: "Il / Elle",
      translationEn: "He / She",
      explanation: "Pronom sujet 3e personne du singulier — pas de distinction de genre en bambara.",
      explanationEn: "Subject pronoun, 3rd person singular — no gender distinction in Bambara.",
      example: "A bɛ sigi. (Il/Elle est assis(e).)",
      exampleEn: "A bɛ sigi. (He/She is sitting.)"
    },
    'An': {
      translation: "Nous",
      translationEn: "We",
      explanation: "Pronom sujet 1re personne du pluriel.",
      explanationEn: "Subject pronoun, 1st person plural.",
      example: "An bɛ nɔgɔ. (Nous travaillons.)",
      exampleEn: "An bɛ nɔgɔ. (We are working.)",
      audio: "Ba-an"
    },
    'Aw': {
      translation: "Vous",
      translationEn: "You (plural)",
      explanation: "Pronom sujet 2e personne du pluriel.",
      explanationEn: "Subject pronoun, 2nd person plural.",
      example: "Aw bɛ taa. (Vous allez.)",
      exampleEn: "Aw bɛ taa. (You are going.)",
      audio: "Ba-aw"
    },
    'U': {
      translation: "Ils / Elles",
      translationEn: "They",
      explanation: "Pronom sujet 3e personne du pluriel.",
      explanationEn: "Subject pronoun, 3rd person plural.",
      example: "U bɛ kalan. (Ils/Elles étudient.)",
      exampleEn: "U bɛ kalan. (They are studying.)",
      audio: "Ba-u"
    },
  },

  'Pronoms objets': {
    'N (objet)': {
      translation: "Me / Moi",
      translationEn: "Me",
      explanation: "Pronom objet 1re personne du singulier. En bambara, le pronom objet se place entre la particule verbale et le verbe.",
      explanationEn: "Object pronoun, 1st person singular. In Bambara, the object pronoun is placed between the verbal particle and the verb.",
      example: "A bɛ n dɛmɛ. (Il/Elle m'aide.)",
      exampleEn: "A bɛ n dɛmɛ. (He/She helps me.)",
      audio: "Ba-n"
    },
    'I (objet)': {
      translation: "Te / Toi",
      translationEn: "You (singular, object)",
      explanation: "Pronom objet 2e personne du singulier.",
      explanationEn: "Object pronoun, 2nd person singular.",
      example: "N bɛ i jɛ. (Je te vois.)",
      exampleEn: "N bɛ i jɛ. (I see you.)",
      audio: "Ba-i"
    },
    'A (objet)': {
      translation: "Le / La / Lui",
      translationEn: "Him / Her / It",
      explanation: "Pronom objet 3e personne du singulier.",
      explanationEn: "Object pronoun, 3rd person singular.",
      example: "N bɛ a dɛmɛ. (Je l'aide.)",
      exampleEn: "N bɛ a dɛmɛ. (I help him/her.)"
    },
    'An (objet)': {
      translation: "Nous",
      translationEn: "Us",
      explanation: "Pronom objet 1re personne du pluriel.",
      explanationEn: "Object pronoun, 1st person plural.",
      example: "U bɛ an dɛmɛ. (Ils/Elles nous aident.)",
      exampleEn: "U bɛ an dɛmɛ. (They help us.)",
      audio: "Ba-an"
    },
    'Aw (objet)': {
      translation: "Vous",
      translationEn: "You (plural, object)",
      explanation: "Pronom objet 2e personne du pluriel.",
      explanationEn: "Object pronoun, 2nd person plural.",
      example: "A bɛ aw fɔ. (Il/Elle vous parle.)",
      exampleEn: "A bɛ aw fɔ. (He/She speaks to you.)",
      audio: "Ba-aw"
    },
    'U (objet)': {
      translation: "Les / Eux",
      translationEn: "Them",
      explanation: "Pronom objet 3e personne du pluriel.",
      explanationEn: "Object pronoun, 3rd person plural.",
      example: "N bɛ u jɛ. (Je les vois.)",
      exampleEn: "N bɛ u jɛ. (I see them.)",
      audio: "Ba-u"
    },
  },

  'Pronoms possessifs': {
    'N ka': {
      translation: "Mon / Ma / Mes",
      translationEn: "My",
      explanation: "Possessif 1re personne du singulier. En bambara, la possession se marque avec 'ka' entre le possesseur et le nom possédé.",
      explanationEn: "Possessive, 1st person singular. In Bambara, possession is marked with 'ka' between the possessor and the possessed noun.",
      example: "N ka so bɛ bɛɛsi. (Ma maison est grande.)",
      exampleEn: "N ka so bɛ bɛɛsi. (My house is big.)",
      audio: "Ba-n_ka"
    },
    'I ka': {
      translation: "Ton / Ta / Tes",
      translationEn: "Your (singular)",
      explanation: "Possessif 2e personne du singulier.",
      explanationEn: "Possessive, 2nd person singular.",
      example: "I ka den bɛ kalan. (Ton enfant étudie.)",
      exampleEn: "I ka den bɛ kalan. (Your child is studying.)",
      audio: "Ba-i_ka"
    },
    'A ka': {
      translation: "Son / Sa / Ses",
      translationEn: "His / Her",
      explanation: "Possessif 3e personne du singulier.",
      explanationEn: "Possessive, 3rd person singular.",
      example: "A ka so bɛɛsi ye. (Sa maison est grande.)",
      exampleEn: "A ka so bɛɛsi ye. (His/Her house is big.)",
      audio: "Ba-a_ka"
    },
    'An ka': {
      translation: "Notre / Nos",
      translationEn: "Our",
      explanation: "Possessif 1re personne du pluriel.",
      explanationEn: "Possessive, 1st person plural.",
      example: "An ka so kɔnɔ bɛ mɔgɔ ca. (Dans notre maison il y a beaucoup de monde.)",
      exampleEn: "An ka so kɔnɔ bɛ mɔgɔ ca. (There are many people in our house.)",
      audio: "Ba-an_ka"
    },
    'Aw ka': {
      translation: "Votre / Vos",
      translationEn: "Your (plural)",
      explanation: "Possessif 2e personne du pluriel.",
      explanationEn: "Possessive, 2nd person plural.",
      example: "Aw ka kalan nyuman ye. (Votre leçon est bonne.)",
      exampleEn: "Aw ka kalan nyuman ye. (Your lesson is good.)",
      audio: "Ba-aw_ka"
    },
    'U ka': {
      translation: "Leur / Leurs",
      translationEn: "Their",
      explanation: "Possessif 3e personne du pluriel.",
      explanationEn: "Possessive, 3rd person plural.",
      example: "U ka nɔgɔ ka ca. (Leur travail est abondant.)",
      exampleEn: "U ka nɔgɔ ka ca. (Their work is abundant.)",
      audio: "Ba-u_ka"
    },
  },

  'Pronoms emphatiques et réfléchis': {
    'N kɔ': {
      translation: "Moi (insistance)",
      translationEn: "Me (emphatic)",
      explanation: "Forme emphatique 1re personne du singulier — insiste sur le sujet qui accomplit l'action.",
      explanationEn: "Emphatic form, 1st person singular — emphasizes the subject performing the action.",
      example: "N kɔ bɛ taa. (Moi, je vais.)",
      exampleEn: "N kɔ bɛ taa. (As for me, I'm going.)",
      audio: "Ba-n_ko"
    },
    'I kɔ': {
      translation: "Toi (insistance)",
      translationEn: "You (emphatic)",
      explanation: "Forme emphatique 2e personne du singulier.",
      explanationEn: "Emphatic form, 2nd person singular.",
      example: "I kɔ bɛ dɛmɛ? (C'est toi qui aides ?)",
      exampleEn: "I kɔ bɛ dɛmɛ? (Is it you who is helping?)",
      audio: "Ba-i_ko"
    },
    'A kɔ': {
      translation: "Lui / Elle (insistance)",
      translationEn: "Him / Her (emphatic)",
      explanation: "Forme emphatique 3e personne du singulier.",
      explanationEn: "Emphatic form, 3rd person singular.",
      example: "A kɔ ye a kɛ. (C'est lui/elle qui l'a fait.)",
      exampleEn: "A kɔ ye a kɛ. (It is he/she who did it.)",
      audio: "Ba-a_ko"
    },
    'N yɛrɛ': {
      translation: "Moi-même",
      translationEn: "Myself",
      explanation: "Forme réflexive 1re personne — insiste sur le fait que le sujet agit sur lui-même ou seul.",
      explanationEn: "Reflexive form, 1st person — emphasizes that the subject acts on itself or alone.",
      example: "N yɛrɛ n'a kɛ. (Je l'ai fait moi-même.)",
      exampleEn: "N yɛrɛ n'a kɛ. (I did it myself.)",
      audio: "Ba-n_yere"
    },
    'A yɛrɛ': {
      translation: "Lui-même / Elle-même",
      translationEn: "Himself / Herself",
      explanation: "Forme réflexive 3e personne du singulier.",
      explanationEn: "Reflexive form, 3rd person singular.",
      example: "A yɛrɛ a kɛra. (Il/Elle l'a fait lui/elle-même.)",
      exampleEn: "A yɛrɛ a kɛra. (He/She did it himself/herself.)",
      audio: "Ba-a_yere"
    },
    'An yɛrɛ': {
      translation: "Nous-mêmes",
      translationEn: "Ourselves",
      explanation: "Forme réflexive 1re personne du pluriel.",
      explanationEn: "Reflexive form, 1st person plural.",
      example: "An yɛrɛ an'a kɛ. (Nous l'avons fait nous-mêmes.)",
      exampleEn: "An yɛrɛ an'a kɛ. (We did it ourselves.)",
      audio: "Ba-an_yere"
    },
  },

  'Pronoms Interrogatifs': {
    'Jɔɔn': {
      translation: "Qui",
      translationEn: "Who",
      explanation: "Interroge sur une personne. Se place en début ou fin de proposition.",
      explanationEn: "Asks about a person. Placed at the beginning or end of the clause.",
      example: "Jɔɔn bɛ naa? (Qui arrive ?)",
      exampleEn: "Jɔɔn bɛ naa? (Who is coming?)",
      audio: "Ba-joon"
    },
    'Mun': {
      translation: "Quoi",
      translationEn: "What",
      explanation: "Interroge sur une chose ou une action.",
      explanationEn: "Asks about a thing or an action.",
      example: "I bɛ mun kɛ? (Que fais-tu ?)",
      exampleEn: "I bɛ mun kɛ? (What are you doing?)",
      audio: "Ba-mun"
    },
    'Min': {
      translation: "Lequel / Laquelle",
      translationEn: "Which one",
      explanation: "Interroge sur un choix ou une précision parmi plusieurs éléments.",
      explanationEn: "Asks about a choice or a specification among several elements.",
      example: "Min so i bɛ fɛ? (Quelle maison aimes-tu ?)",
      exampleEn: "Min so i bɛ fɛ? (Which house do you like?)",
      audio: "Ba-min"
    },
    'Yɔrɔ mun': {
      translation: "Où",
      translationEn: "Where",
      explanation: "'Yɔrɔ' = lieu + 'mun' = quoi. Littéralement 'quel endroit ?'",
      explanationEn: "'Yɔrɔ' = place + 'mun' = what. Literally 'what place?'",
      example: "I bɛ taa yɔrɔ mun? (Où vas-tu ?)",
      exampleEn: "I bɛ taa yɔrɔ mun? (Where are you going?)"
    },
    'Waati mun': {
      translation: "Quand",
      translationEn: "When",
      explanation: "'Waati' = moment/heure + 'mun' = quoi. Interroge sur le temps.",
      explanationEn: "'Waati' = moment/time + 'mun' = what. Asks about time.",
      example: "Waati mun i bɛ naa? (Quand est-ce que tu arrives ?)",
      exampleEn: "Waati mun i bɛ naa? (When do you arrive?)"
    },
    'Cogo mun': {
      translation: "Comment",
      translationEn: "How",
      explanation: "'Cogo' = manière + 'mun' = quoi. Interroge sur la façon de faire.",
      explanationEn: "'Cogo' = manner + 'mun' = what. Asks about the way something is done.",
      example: "Cogo mun i bɛ kɛ? (Comment fais-tu ?)",
      exampleEn: "Cogo mun i bɛ kɛ? (How do you do it?)",
      audio: "Ba-cogomun"
    },
    'Mun na': {
      translation: "Pourquoi",
      translationEn: "Why",
      explanation: "'Mun na' = à cause de quoi. Interroge sur la cause.",
      explanationEn: "'Mun na' = because of what. Asks about the cause.",
      example: "Mun na i tɛ naa? (Pourquoi tu ne viens pas ?)",
      exampleEn: "Mun na i tɛ naa? (Why aren't you coming?)",
      audio: "Ba-munna"
    },
  },

  // ============================================================
  // UNITÉ 2 — PARTICULES VERBALES, TEMPS & NÉGATION
  // ============================================================

  'Particules verbales': {
    'Bɛ': {
      translation: "Présent / état",
      translationEn: "Present / state",
      explanation: "Particule du présent inaccompli — action actuelle, habituelle ou vérité générale. Structure : Sujet + bɛ + verbe.",
      explanationEn: "Present imperfective particle — current, habitual action or general truth. Structure: Subject + bɛ + verb.",
      example: "N bɛ kalan. (J'étudie. / Je suis en train d'étudier.)",
      exampleEn: "N bɛ kalan. (I study. / I am studying.)"
    },
    'Bi': {
      translation: "Progressif (en train de)",
      translationEn: "Progressive (in the process of)",
      explanation: "Particule progressive — action en cours au moment précis où l'on parle. Plus immédiat que 'bɛ'.",
      explanationEn: "Progressive particle — action underway at the exact moment of speaking. More immediate than 'bɛ'.",
      example: "N bi kalan. (Je suis en train d'étudier — maintenant.)",
      exampleEn: "N bi kalan. (I am studying — right now.)"
    },
    'Ye': {
      translation: "Passé accompli (transitif)",
      translationEn: "Past completed (transitive)",
      explanation: "Particule du passé quand le verbe a un objet direct. Structure : Sujet + ye + Objet + Verbe.",
      explanationEn: "Past particle used when the verb has a direct object. Structure: Subject + ye + Object + Verb.",
      example: "N ye dumuni kɛ. (J'ai fait la cuisine.)",
      exampleEn: "N ye dumuni kɛ. (I cooked / I made the meal.)"
    },
    'Ra / La / Na': {
      translation: "Passé accompli (intransitif)",
      translationEn: "Past completed (intransitive)",
      explanation: "Suffixe de passé s'accolant au verbe intransitif (sans objet). La forme varie selon la terminaison du verbe (-ra, -la ou -na).",
      explanationEn: "Past suffix attached to an intransitive verb (without an object). The form varies according to the verb's ending (-ra, -la or -na).",
      example: "A taara. (Il/Elle est parti(e).) / A donna. (Il/Elle est entré(e).)",
      exampleEn: "A taara. (He/She left.) / A donna. (He/She entered.)"
    },
    'Bɛna': {
      translation: "Futur",
      translationEn: "Future",
      explanation: "Particule du futur — action qui va se produire. Structure : Sujet + bɛna + verbe.",
      explanationEn: "Future particle — an action that is going to happen. Structure: Subject + bɛna + verb.",
      example: "N bɛna taa. (Je vais partir / J'irai.)",
      exampleEn: "N bɛna taa. (I am going to leave / I will go.)"
    },
    'Tɛ': {
      translation: "Négation du présent",
      translationEn: "Present negation",
      explanation: "Particule négative du présent — remplace 'bɛ' dans la construction négative.",
      explanationEn: "Negative particle for the present — replaces 'bɛ' in the negative construction.",
      example: "N tɛ kalan. (Je n'étudie pas.)",
      exampleEn: "N tɛ kalan. (I do not study.)"
    },
    'Ma': {
      translation: "Négation du passé",
      translationEn: "Past negation",
      explanation: "Particule négative du passé — remplace 'ye/ra' dans la construction négative.",
      explanationEn: "Negative particle for the past — replaces 'ye/ra' in the negative construction.",
      example: "N ma taa. (Je ne suis pas parti(e).)",
      exampleEn: "N ma taa. (I did not leave.)"
    },
    'Tɛna': {
      translation: "Négation du futur",
      translationEn: "Future negation",
      explanation: "Particule négative du futur — remplace 'bɛna' dans la construction négative.",
      explanationEn: "Negative particle for the future — replaces 'bɛna' in the negative construction.",
      example: "N tɛna taa. (Je n'irai pas.)",
      exampleEn: "N tɛna taa. (I will not go.)"
    },
    'Tun': {
      translation: "Passé lointain / narratif",
      translationEn: "Distant / narrative past",
      explanation: "'Tun' se place avant la particule pour indiquer un passé antérieur ou un contexte narratif (imparfait, plus-que-parfait).",
      explanationEn: "'Tun' is placed before the particle to indicate an earlier past or a narrative context (imperfect, pluperfect).",
      example: "N tun bɛ kalan. (J'étudiais. — sujet + tun + bɛ + verbe)",
      exampleEn: "N tun bɛ kalan. (I used to study / I was studying. — subject + tun + bɛ + verb)"
    },
    'Ka': {
      translation: "Subjonctif / souhait / but",
      translationEn: "Subjunctive / wish / purpose",
      explanation: "'Ka' exprime un souhait, un ordre indirect ou un but. Structure : Sujet + ka + verbe.",
      explanationEn: "'Ka' expresses a wish, an indirect command or a purpose. Structure: Subject + ka + verb.",
      example: "A ka taa so la! (Qu'il/elle aille à la maison !)",
      exampleEn: "A ka taa so la! (Let him/her go home!)"
    },
    'Kana': {
      translation: "Impératif négatif",
      translationEn: "Negative imperative",
      explanation: "'Kana' interdit une action — équivalent de 'ne...pas' à l'impératif. Structure : Kana + verbe.",
      explanationEn: "'Kana' forbids an action — equivalent to 'do not' in the imperative. Structure: Kana + verb.",
      example: "Kana taa yan! (N'y va pas !)",
      exampleEn: "Kana taa yan! (Don't go there!)"
    },
    'Bɛ...kɛ': {
      translation: "Être en train de faire",
      translationEn: "To be in the process of doing",
      explanation: "Construction progressive avec un verbe d'action nominalisé : Sujet + bɛ + nom d'action + kɛ.",
      explanationEn: "Progressive construction with a nominalized action verb: Subject + bɛ + action noun + kɛ.",
      example: "A bɛ kalan kɛ. (Il/Elle est en train de faire ses études.)",
      exampleEn: "A bɛ kalan kɛ. (He/She is studying.)"
    },
  },

  'Temps verbaux — Présent': {
    'N bɛ taa': {
      translation: "Je vais",
      translationEn: "I am going",
      explanation: "Présent 1re personne du singulier avec la particule 'bɛ'.",
      explanationEn: "Present tense, 1st person singular with the particle 'bɛ'.",
      example: "N bɛ taa so la tile kelen kelen. (Je vais à la maison chaque jour.)",
      exampleEn: "N bɛ taa so la tile kelen kelen. (I go home every day.)"
    },
    'I bɛ taa': {
      translation: "Tu vas",
      translationEn: "You are going",
      explanation: "Présent 2e personne du singulier.",
      explanationEn: "Present tense, 2nd person singular.",
      example: "I bɛ taa yɔrɔ mun? (Où vas-tu ?)",
      exampleEn: "I bɛ taa yɔrɔ mun? (Where are you going?)"
    },
    'A bɛ taa': {
      translation: "Il / Elle va",
      translationEn: "He / She is going",
      explanation: "Présent 3e personne du singulier.",
      explanationEn: "Present tense, 3rd person singular.",
      example: "A bɛ taa so la tile kelen kelen. (Il/Elle va à la maison chaque jour.)",
      exampleEn: "A bɛ taa so la tile kelen kelen. (He/She goes home every day.)"
    },
    'An bɛ taa': {
      translation: "Nous allons",
      translationEn: "We are going",
      explanation: "Présent 1re personne du pluriel.",
      explanationEn: "Present tense, 1st person plural.",
      example: "An bɛ taa duguma la sini. (Nous allons en ville demain.)",
      exampleEn: "An bɛ taa duguma la sini. (We are going to town tomorrow.)"
    },
    'Aw bɛ taa': {
      translation: "Vous allez",
      translationEn: "You (plural) are going",
      explanation: "Présent 2e personne du pluriel.",
      explanationEn: "Present tense, 2nd person plural.",
      example: "Aw bɛ taa wa? (Vous y allez ?)",
      exampleEn: "Aw bɛ taa wa? (Are you going?)"
    },
    'U bɛ taa': {
      translation: "Ils / Elles vont",
      translationEn: "They are going",
      explanation: "Présent 3e personne du pluriel.",
      explanationEn: "Present tense, 3rd person plural.",
      example: "U bɛ taa marché la sɔgɔma kelen kelen. (Ils/Elles vont au marché chaque matin.)",
      exampleEn: "U bɛ taa marché la sɔgɔma kelen kelen. (They go to the market every morning.)"
    },
  },

  'Temps verbaux — Passé': {
    'N taara': {
      translation: "Je suis parti(e)",
      translationEn: "I left",
      explanation: "Passé accompli intransitif 1re personne du singulier. Le suffixe '-ra' s'attache au verbe 'taa'.",
      explanationEn: "Intransitive completed past, 1st person singular. The suffix '-ra' attaches to the verb 'taa'.",
      example: "N taara duguma la kunun. (Je suis allé(e) en ville hier.)",
      exampleEn: "N taara duguma la kunun. (I went to town yesterday.)"
    },
    'A taara': {
      translation: "Il / Elle est parti(e)",
      translationEn: "He / She left",
      explanation: "Passé accompli intransitif 3e personne du singulier — la forme la plus naturelle du passé en bambara.",
      explanationEn: "Intransitive completed past, 3rd person singular — the most natural past form in Bambara.",
      example: "A taara duguma. (Il/Elle est allé(e) en ville.)",
      exampleEn: "A taara duguma. (He/She went to town.)"
    },
    'An taara': {
      translation: "Nous sommes parti(e)s",
      translationEn: "We left",
      explanation: "Passé accompli intransitif 1re personne du pluriel.",
      explanationEn: "Intransitive completed past, 1st person plural.",
      example: "An taara kunun sɔgɔma. (Nous sommes parti(e)s hier matin.)",
      exampleEn: "An taara kunun sɔgɔma. (We left yesterday morning.)"
    },
    'N ye a jɛ': {
      translation: "Je l'ai vu(e)",
      translationEn: "I saw him/her",
      explanation: "Passé accompli transitif 1re personne. Structure : N (sujet) + ye (passé transitif) + a (objet) + jɛ (verbe).",
      explanationEn: "Transitive completed past, 1st person. Structure: N (subject) + ye (transitive past) + a (object) + jɛ (verb).",
      example: "N ye a jɛ marché la. (Je l'ai vu(e) au marché.)",
      exampleEn: "N ye a jɛ marché la. (I saw him/her at the market.)"
    },
    'A ye n jɛ': {
      translation: "Il / Elle m'a vu(e)",
      translationEn: "He / She saw me",
      explanation: "Passé accompli transitif 3e personne. L'objet 'n' (me) se place entre 'ye' et le verbe.",
      explanationEn: "Transitive completed past, 3rd person. The object 'n' (me) is placed between 'ye' and the verb.",
      example: "A ye n jɛ kunun. (Il/Elle m'a vu(e) hier.)",
      exampleEn: "A ye n jɛ kunun. (He/She saw me yesterday.)"
    },
    'A tun bɛ taa': {
      translation: "Il / Elle allait (imparfait)",
      translationEn: "He / She used to go (imperfect)",
      explanation: "'Tun' devant 'bɛ' forme l'imparfait — action habituelle ou en cours dans le passé.",
      explanationEn: "'Tun' before 'bɛ' forms the imperfect — a habitual or ongoing action in the past.",
      example: "A tun bɛ taa so la tile kelen kelen. (Il/Elle allait à la maison chaque jour.)",
      exampleEn: "A tun bɛ taa so la tile kelen kelen. (He/She used to go home every day.)"
    },
    'A tun ye n jɛ': {
      translation: "Il / Elle m'avait vu(e) (plus-que-parfait)",
      translationEn: "He / She had seen me (pluperfect)",
      explanation: "'Tun' devant 'ye' forme le plus-que-parfait — action antérieure à une autre action passée.",
      explanationEn: "'Tun' before 'ye' forms the pluperfect — an action prior to another past action.",
      example: "A tun ye n jɛ bɔ a taara. (Il/Elle m'avait vu(e) avant de partir.)",
      exampleEn: "A tun ye n jɛ bɔ a taara. (He/She had seen me before leaving.)"
    },
    'N taara kɔ': {
      translation: "J'y étais allé(e) auparavant",
      translationEn: "I had gone there before",
      explanation: "'Kɔ' après le verbe au passé indique une antériorité ou un fait accompli dans un contexte narratif.",
      explanationEn: "'Kɔ' after the verb in the past indicates precedence or a completed fact in a narrative context.",
      example: "N taara kɔ bɔ i nɔfɛ. (J'y étais allé(e) avant toi.)",
      exampleEn: "N taara kɔ bɔ i nɔfɛ. (I had gone there before you.)"
    },
  },

  'Temps verbaux — Futur': {
    'N bɛna taa': {
      translation: "J'irai",
      translationEn: "I will go",
      explanation: "Futur 1re personne du singulier. 'Bɛna' est la particule du futur, invariable pour toutes les personnes.",
      explanationEn: "Future tense, 1st person singular. 'Bɛna' is the future particle, invariable for all persons.",
      example: "N bɛna taa sini. (J'irai demain.)",
      exampleEn: "N bɛna taa sini. (I will go tomorrow.)"
    },
    'I bɛna taa': {
      translation: "Tu iras",
      translationEn: "You will go",
      explanation: "Futur 2e personne du singulier.",
      explanationEn: "Future tense, 2nd person singular.",
      example: "I bɛna taa ak n? (Tu iras avec moi ?)",
      exampleEn: "I bɛna taa ak n? (Will you go with me?)"
    },
    'A bɛna taa': {
      translation: "Il / Elle ira",
      translationEn: "He / She will go",
      explanation: "Futur 3e personne du singulier.",
      explanationEn: "Future tense, 3rd person singular.",
      example: "A bɛna taa so la sini. (Il/Elle ira à la maison demain.)",
      exampleEn: "A bɛna taa so la sini. (He/She will go home tomorrow.)"
    },
    'An bɛna taa': {
      translation: "Nous irons",
      translationEn: "We will go",
      explanation: "Futur 1re personne du pluriel.",
      explanationEn: "Future tense, 1st person plural.",
      example: "An bɛna taa géej la tile min bɛ. (Nous irons à la plage le jour d'après.)",
      exampleEn: "An bɛna taa géej la tile min bɛ. (We will go to the beach the following day.)"
    },
    'Aw bɛna taa': {
      translation: "Vous irez",
      translationEn: "You (plural) will go",
      explanation: "Futur 2e personne du pluriel.",
      explanationEn: "Future tense, 2nd person plural.",
      example: "Aw bɛna taa wa? (Vous irez ?)",
      exampleEn: "Aw bɛna taa wa? (Will you go?)"
    },
    'U bɛna taa': {
      translation: "Ils / Elles iront",
      translationEn: "They will go",
      explanation: "Futur 3e personne du pluriel.",
      explanationEn: "Future tense, 3rd person plural.",
      example: "U bɛna taa duguma sini. (Ils/Elles iront en ville demain.)",
      exampleEn: "U bɛna taa duguma sini. (They will go to town tomorrow.)"
    },
  },

  'Temps verbaux — Impératif & Subjonctif': {
    'Taa!': {
      translation: "Va ! / Pars !",
      translationEn: "Go!",
      explanation: "Impératif direct 2e personne du singulier. En bambara, l'impératif direct est le verbe seul, sans particule.",
      explanationEn: "Direct imperative, 2nd person singular. In Bambara, the direct imperative is the verb alone, without a particle.",
      example: "Taa so la! (Va à la maison !)",
      exampleEn: "Taa so la! (Go home!)"
    },
    'Aw taa!': {
      translation: "Allez ! / Partez !",
      translationEn: "Go! (plural)",
      explanation: "Impératif direct 2e personne du pluriel — on ajoute le pronom 'aw' pour le pluriel.",
      explanationEn: "Direct imperative, 2nd person plural — the pronoun 'aw' is added for the plural.",
      example: "Aw taa yan ka bɔ! (Allez partir d'ici !)",
      exampleEn: "Aw taa yan ka bɔ! (Go, leave from here!)"
    },
    'Kana taa': {
      translation: "Ne va pas !",
      translationEn: "Don't go!",
      explanation: "Impératif négatif singulier — 'kana' interdit l'action à la 2e personne du singulier.",
      explanationEn: "Negative imperative, singular — 'kana' forbids the action for the 2nd person singular.",
      example: "Kana taa yan! (Ne va pas là-bas !)",
      exampleEn: "Kana taa yan! (Don't go there!)",
      audio: "Ba-Kana_taa"
    },
    'Aw kana taa': {
      translation: "N'allez pas !",
      translationEn: "Don't go! (plural)",
      explanation: "Impératif négatif pluriel.",
      explanationEn: "Negative imperative, plural.",
      example: "Aw kana taa so kɔnɔ! (N'allez pas dans la maison !)",
      exampleEn: "Aw kana taa so kɔnɔ! (Don't go into the house!)",
      audio: "Ba-aw_kana_taa"
    },
    'I ka taa': {
      translation: "Tu devrais aller / Vas-y",
      translationEn: "You should go / Go ahead",
      explanation: "Subjonctif 2e personne — exprime un conseil, une suggestion ou un souhait doux.",
      explanationEn: "Subjunctive, 2nd person — expresses advice, a suggestion or a gentle wish.",
      example: "I ka taa ka a dɛmɛ. (Tu devrais aller l'aider.)",
      exampleEn: "I ka taa ka a dɛmɛ. (You should go help him/her.)",
      audio: "Ba-i_ka_taa"
    },
    'A ka taa': {
      translation: "Qu'il / Elle aille",
      translationEn: "Let him / her go",
      explanation: "Subjonctif 3e personne — ordre indirect ou souhait.",
      explanationEn: "Subjunctive, 3rd person — indirect command or wish.",
      example: "A ka taa so la! (Qu'il/elle aille à la maison !)",
      exampleEn: "A ka taa so la! (Let him/her go home!)",
      audio: "Ba-a_ka_taa"
    },
    'An ka taa': {
      translation: "Allons-y !",
      translationEn: "Let's go!",
      explanation: "Subjonctif 1re personne du pluriel — équivalent de 'allons' en français.",
      explanationEn: "Subjunctive, 1st person plural — equivalent to 'let's go' in English.",
      example: "An ka taa duguma la! (Allons en ville !)",
      exampleEn: "An ka taa duguma la! (Let's go to town!)",
      audio: "Ba-an_ka_taa"
    },
  },

  'Négation': {
    'N tɛ taa': {
      translation: "Je ne vais pas",
      translationEn: "I am not going",
      explanation: "Négation du présent 1re personne du singulier. 'Tɛ' remplace 'bɛ' dans toutes les constructions négatives au présent.",
      explanationEn: "Present negation, 1st person singular. 'Tɛ' replaces 'bɛ' in all negative present constructions.",
      example: "N tɛ taa so la tuma min. (Je ne vais pas à la maison maintenant.)",
      exampleEn: "N tɛ taa so la tuma min. (I am not going home right now.)",
      audio: "Ba-n_te_taa"
    },
    'A tɛ taa': {
      translation: "Il / Elle ne va pas",
      translationEn: "He / She is not going",
      explanation: "Négation du présent 3e personne du singulier.",
      explanationEn: "Present negation, 3rd person singular.",
      example: "A tɛ taa so la. (Il/Elle ne va pas à la maison.)",
      exampleEn: "A tɛ taa so la. (He/She is not going home.)",
      audio: "Ba-a_te_taa"
    },
    'N ma taa': {
      translation: "Je ne suis pas parti(e)",
      translationEn: "I did not leave",
      explanation: "Négation du passé 1re personne. 'Ma' remplace 'ye/ra' pour le passé négatif.",
      explanationEn: "Past negation, 1st person. 'Ma' replaces 'ye/ra' for the negative past.",
      example: "N ma taa marché la kunun. (Je ne suis pas allé(e) au marché hier.)",
      exampleEn: "N ma taa marché la kunun. (I did not go to the market yesterday.)",
      audio: "Ba-n_ma_taa"
    },
    'A ma taa': {
      translation: "Il / Elle n'est pas parti(e)",
      translationEn: "He / She did not leave",
      explanation: "Négation du passé 3e personne du singulier.",
      explanationEn: "Past negation, 3rd person singular.",
      example: "A ma taa marché la. (Il/Elle n'est pas allé(e) au marché.)",
      exampleEn: "A ma taa marché la. (He/She did not go to the market.)",
      audio: "Ba-a_ma_taa"
    },
    'N tɛna taa': {
      translation: "Je n'irai pas",
      translationEn: "I will not go",
      explanation: "Négation du futur 1re personne. 'Tɛna' remplace 'bɛna' pour le futur négatif.",
      explanationEn: "Future negation, 1st person. 'Tɛna' replaces 'bɛna' for the negative future.",
      example: "N tɛna taa duguma la sini. (Je n'irai pas en ville demain.)",
      exampleEn: "N tɛna taa duguma la sini. (I will not go to town tomorrow.)",
      audio: "Ba-n_tena_taa"
    },
    'A tɛna taa': {
      translation: "Il / Elle n'ira pas",
      translationEn: "He / She will not go",
      explanation: "Négation du futur 3e personne du singulier.",
      explanationEn: "Future negation, 3rd person singular.",
      example: "A tɛna taa duguma. (Il/Elle n'ira pas en ville.)",
      exampleEn: "A tɛna taa duguma. (He/She will not go to town.)",
      audio: "Ba-a_tena_taa"
    },
    'Kana taa': {
      translation: "Ne va pas ! (défense)",
      translationEn: "Don't go! (prohibition)",
      explanation: "'Kana' est la négation de l'impératif — interdit une action à quelqu'un.",
      explanationEn: "'Kana' is the negation of the imperative — forbids an action to someone.",
      example: "Kana taa yan! (N'y va pas !)",
      exampleEn: "Kana taa yan! (Don't go there!)"
    },
    'A tɛ... ye': {
      translation: "Il / Elle n'est pas...",
      translationEn: "He / She is not...",
      explanation: "Négation attributive — pour nier une identité ou un état. Structure : Sujet + tɛ + attribut + ye.",
      explanationEn: "Attributive negation — used to deny an identity or a state. Structure: Subject + tɛ + attribute + ye.",
      example: "A tɛ jàngalekat ye. (Il/Elle n'est pas enseignant(e).)",
      exampleEn: "A tɛ jàngalekat ye. (He/She is not a teacher.)"
    },
  },

  // ============================================================
  // UNITÉ 3 — POSTPOSITIONS, ADJECTIFS, ADVERBES & CONJONCTIONS
  // ============================================================

  'Postpositions de lieu': {
    'La': {
      translation: "À / Vers (destination)",
      translationEn: "To / Towards (destination)",
      explanation: "Postposition de destination ou de but. Se place après le nom. Équivalent du 'à' ou 'vers' français.",
      explanationEn: "Postposition of destination or purpose. Placed after the noun. Equivalent to 'to' or 'towards' in English.",
      example: "N bɛ taa duguma la. (Je vais en ville.)",
      exampleEn: "N bɛ taa duguma la. (I am going to town.)"
    },
    'Kɔnɔ': {
      translation: "Dans, à l'intérieur de",
      translationEn: "In, inside",
      explanation: "Postposition d'intériorité.",
      explanationEn: "Postposition of interiority.",
      example: "A bɛ so kɔnɔ. (Il/Elle est dans la maison.)",
      exampleEn: "A bɛ so kɔnɔ. (He/She is inside the house.)",
      audio: "Ba-kono"
    },
    'Kan': {
      translation: "Sur, au-dessus de",
      translationEn: "On, above",
      explanation: "Postposition de surface ou de superposition.",
      explanationEn: "Postposition of surface or superposition.",
      example: "A bɛ tabali kan. (Il/Elle est sur la table.)",
      exampleEn: "A bɛ tabali kan. (He/She is on the table.)",
      audio: "Ba-kan"
    },
    'Fɛ': {
      translation: "Près de / Chez / Avec",
      translationEn: "Near / At (someone's place) / With",
      explanation: "'Fɛ' indique la proximité physique, la possession ou l'accompagnement selon le contexte.",
      explanationEn: "'Fɛ' indicates physical proximity, possession or accompaniment depending on context.",
      example: "A bɛ n fɛ. (Il/Elle est près de moi / Il/Elle est avec moi.)",
      exampleEn: "A bɛ n fɛ. (He/She is near me / He/She is with me.)"
    },
    'Kɔ': {
      translation: "Derrière / Après",
      translationEn: "Behind / After",
      explanation: "Postposition de position arrière ou temporelle.",
      explanationEn: "Postposition of rear position or of time.",
      example: "A bɛ so kɔ. (Il/Elle est derrière la maison.)",
      exampleEn: "A bɛ so kɔ. (He/She is behind the house.)"
    },
    'Kɔrɔ': {
      translation: "Sous / En dessous de / Avant (temporel)",
      translationEn: "Under / Below / Before (temporal)",
      explanation: "'Kɔrɔ' indique une position inférieure dans l'espace ou une antériorité dans le temps.",
      explanationEn: "'Kɔrɔ' indicates a lower position in space or precedence in time.",
      example: "A bɛ ji kɔrɔ. (Il/Elle est sous l'eau.) / A taara n kɔrɔ. (Il/Elle est parti(e) avant moi.)",
      exampleEn: "A bɛ ji kɔrɔ. (He/She is under the water.) / A taara n kɔrɔ. (He/She left before me.)",
      audio: "Ba-koro"
    },
    'Kɛrɛfɛ': {
      translation: "À côté de",
      translationEn: "Next to",
      explanation: "Postposition de proximité latérale.",
      explanationEn: "Postposition of lateral proximity.",
      example: "Tɔgɔ so kɛrɛfɛ. (La maison d'à côté.)",
      exampleEn: "Tɔgɔ so kɛrɛfɛ. (The house next door.)"
    },
    'Nɔfɛ': {
      translation: "Devant / En face de",
      translationEn: "In front of / Facing",
      explanation: "Postposition indiquant une position frontale.",
      explanationEn: "Postposition indicating a frontal position.",
      example: "A tɔgɔ bɛ n nɔfɛ. (Il/Elle se tient devant moi.)",
      exampleEn: "A tɔgɔ bɛ n nɔfɛ. (He/She stands in front of me.)"
    },
    'Ni': {
      translation: "Avec",
      translationEn: "With",
      explanation: "'Ni' marque l'accompagnement ou la conjonction entre deux entités.",
      explanationEn: "'Ni' marks accompaniment or the conjunction between two entities.",
      example: "N bɛna taa ak i ni jɔɔn? (J'irai avec toi et qui d'autre ?)",
      exampleEn: "N bɛna taa ak i ni jɔɔn? (I will go with you and who else?)"
    },
    'Cɛ': {
      translation: "Entre",
      translationEn: "Between",
      explanation: "Postposition indiquant une position intermédiaire entre deux éléments.",
      explanationEn: "Postposition indicating an intermediate position between two elements.",
      example: "A bɛ Moussa ni Fatoumata cɛ. (Il/Elle est entre Moussa et Fatoumata.)",
      exampleEn: "A bɛ Moussa ni Fatoumata cɛ. (He/She is between Moussa and Fatoumata.)"
    },
  },

  'Postpositions de temps et de cause': {
    'Tuma min': {
      translation: "Quand / Au moment où",
      translationEn: "When / At the moment when",
      explanation: "Locution conjonctive temporelle — introduit une proposition temporelle.",
      explanationEn: "Temporal conjunctive phrase — introduces a temporal clause.",
      example: "Tuma min n taara, a tun bɛ sigi. (Quand je suis parti(e), il/elle était assis(e).)",
      exampleEn: "Tuma min n taara, a tun bɛ sigi. (When I left, he/she was sitting.)"
    },
    'Sani': {
      translation: "Avant que / Avant de",
      translationEn: "Before",
      explanation: "Exprime l'antériorité — l'action principale se déroule avant l'action subordonnée.",
      explanationEn: "Expresses precedence — the main action takes place before the subordinate action.",
      example: "Sani i ka taa, wele n. (Avant de partir, appelle-moi.)",
      exampleEn: "Sani i ka taa, wele n. (Before leaving, call me.)"
    },
    'Ka ban': {
      translation: "Après que / Après avoir",
      translationEn: "After",
      explanation: "'Ka ban' = après la fin de. Introduit une action postérieure.",
      explanationEn: "'Ka ban' = after the end of. Introduces a subsequent action.",
      example: "Ka dumuni kɛ ka ban, a taara. (Après avoir mangé, il/elle est parti(e).)",
      exampleEn: "Ka dumuni kɛ ka ban, a taara. (After eating, he/she left.)",
      audio: "Ba-ka_ban"
    },
    'Bari': {
      translation: "Parce que / Car",
      translationEn: "Because",
      explanation: "'Bari' introduit une proposition causale.",
      explanationEn: "'Bari' introduces a causal clause.",
      example: "N ma taa bari n tun bɛ bana. (Je ne suis pas parti(e) parce que j'étais malade.)",
      exampleEn: "N ma taa bari n tun bɛ bana. (I did not leave because I was sick.)"
    },
    'Ka kɔrɔ': {
      translation: "Depuis / Il y a",
      translationEn: "Since / Ago",
      explanation: "Exprime le point de départ dans le temps.",
      explanationEn: "Expresses the starting point in time.",
      example: "Ka kɔrɔ aw tagara, an bɛ aw kɔnɔn. (Depuis que vous êtes partis, nous pensons à vous.)",
      exampleEn: "Ka kɔrɔ aw tagara, an bɛ aw kɔnɔn. (Since you left, we have been thinking of you.)"
    },
    'Fɔlɔ': {
      translation: "D'abord / En premier",
      translationEn: "First / At first",
      explanation: "Indique la première action d'une séquence.",
      explanationEn: "Indicates the first action in a sequence.",
      example: "Fɔlɔ, i ka dumuni kɛ, a kɔ i bɛna taa. (D'abord mange, ensuite tu partiras.)",
      exampleEn: "Fɔlɔ, i ka dumuni kɛ, a kɔ i bɛna taa. (First eat, then you will leave.)"
    },
  },

  'Adjectifs — Apparence et taille': {
    'Dɔɔrɔman': {
      translation: "Beau, belle",
      translationEn: "Beautiful, handsome",
      explanation: "Décrit une apparence agréable. En bambara, les adjectifs suivent directement le nom.",
      explanationEn: "Describes a pleasant appearance. In Bambara, adjectives directly follow the noun.",
      example: "A ka muso dɔɔrɔman ye. (Sa femme est belle.)",
      exampleEn: "A ka muso dɔɔrɔman ye. (His wife is beautiful.)"
    },
    'Nyɛ': {
      translation: "Joli, agréable à voir",
      translationEn: "Pretty, pleasant to look at",
      explanation: "Beauté visuelle douce, souvent pour les objets ou les lieux.",
      explanationEn: "Gentle visual beauty, often used for objects or places.",
      example: "So nin nyɛ ye. (Cette maison est jolie.)",
      exampleEn: "So nin nyɛ ye. (This house is pretty.)"
    },
    'Bɛɛsi': {
      translation: "Grand, large, important",
      translationEn: "Big, wide, important",
      explanation: "Décrit une grande taille ou une grande importance.",
      explanationEn: "Describes a large size or great importance.",
      example: "N ka so bɛɛsi ye. (Ma maison est grande.)",
      exampleEn: "N ka so bɛɛsi ye. (My house is big.)"
    },
    'Garaw': {
      translation: "Grand (taille humaine)",
      translationEn: "Tall (human height)",
      explanation: "Spécifiquement pour décrire la taille d'une personne.",
      explanationEn: "Specifically used to describe a person's height.",
      example: "A ka cɛ garaw ye. (Cet homme est grand.)",
      exampleEn: "A ka cɛ garaw ye. (This man is tall.)"
    },
    'Dimin': {
      translation: "Petit, petite",
      translationEn: "Small",
      explanation: "Décrit une petite taille ou une faible quantité.",
      explanationEn: "Describes a small size or a small quantity.",
      example: "A ka den dimin ye. (Son enfant est petit.)",
      exampleEn: "A ka den dimin ye. (His/Her child is small.)"
    },
    'Bɛnkɛn': {
      translation: "Minuscule, tout petit",
      translationEn: "Tiny",
      explanation: "Petite taille extrême.",
      explanationEn: "Extremely small size.",
      example: "Jiri nin bɛnkɛn ye. (Cet arbre est minuscule.)",
      exampleEn: "Jiri nin bɛnkɛn ye. (This tree is tiny.)"
    },
    'Kɛrɛnkɛrɛn': {
      translation: "Énorme, très grand",
      translationEn: "Huge, very big",
      explanation: "Grande taille impressionnante.",
      explanationEn: "Impressively large size.",
      example: "So nin kɛrɛnkɛrɛn ye. (Cette maison est énorme.)",
      exampleEn: "So nin kɛrɛnkɛrɛn ye. (This house is huge.)"
    },
    'Tɛmɛ': {
      translation: "Long",
      translationEn: "Long",
      explanation: "Décrit une longueur ou une durée.",
      explanationEn: "Describes a length or a duration.",
      example: "A ka sira tɛmɛ ye. (La route est longue.)",
      exampleEn: "A ka sira tɛmɛ ye. (The road is long.)"
    },
  },

  'Adjectifs — Caractère et comportement': {
    'Nyuman': {
      translation: "Bon, bien",
      translationEn: "Good, well",
      explanation: "Adjectif positif polyvalent, très courant en bambara.",
      explanationEn: "Versatile positive adjective, very common in Bambara.",
      example: "A ka nɔgɔ nyuman ye. (Son travail est bon.)",
      exampleEn: "A ka nɔgɔ nyuman ye. (His/Her work is good.)"
    },
    'Fon': {
      translation: "Mauvais",
      translationEn: "Bad",
      explanation: "Opposé de 'nyuman'.",
      explanationEn: "Opposite of 'nyuman'.",
      example: "A ka kalan fon ye. (Sa leçon est mauvaise.)",
      exampleEn: "A ka kalan fon ye. (His/Her lesson is bad.)"
    },
    'Fari': {
      translation: "Courageux, brave",
      translationEn: "Courageous, brave",
      explanation: "Absence de peur face au danger.",
      explanationEn: "Absence of fear in the face of danger.",
      example: "A fari ye. (Il/Elle est courageux/courageuse.)",
      exampleEn: "A fari ye. (He/She is courageous.)"
    },
    'Jugu': {
      translation: "Mauvais, méchant",
      translationEn: "Bad, mean",
      explanation: "Caractère négatif ou comportement nuisible.",
      explanationEn: "Negative character or harmful behavior.",
      example: "A jugu ye. (Il/Elle est méchant(e).)",
      exampleEn: "A jugu ye. (He/She is mean.)"
    },
    'Juman': {
      translation: "Honnête, droit",
      translationEn: "Honest, upright",
      explanation: "Droiture morale et honnêteté.",
      explanationEn: "Moral uprightness and honesty.",
      example: "A juman ye. (Il/Elle est honnête.)",
      exampleEn: "A juman ye. (He/She is honest.)"
    },
    'Sabali': {
      translation: "Patient, endurant",
      translationEn: "Patient, enduring",
      explanation: "Qualité morale très valorisée dans la culture bambara.",
      explanationEn: "A moral quality highly valued in Bambara culture.",
      example: "A bɛ sabali sɔrɔ. (Il/Elle est patient(e).)",
      exampleEn: "A bɛ sabali sɔrɔ. (He/She is patient.)"
    },
    'Surun': {
      translation: "Intelligent, sage",
      translationEn: "Intelligent, wise",
      explanation: "Décrit une intelligence ou une sagesse pratique.",
      explanationEn: "Describes intelligence or practical wisdom.",
      example: "A surun ye. (Il/Elle est intelligent(e).)",
      exampleEn: "A surun ye. (He/She is intelligent.)"
    },
    'Mɔgɔya': {
      translation: "Humanité, gentillesse",
      translationEn: "Humanity, kindness",
      explanation: "'Mɔgɔya' désigne la qualité d'être pleinement humain — compassion et générosité. Concept fondamental en Afrique de l'Ouest.",
      explanationEn: "'Mɔgɔya' refers to the quality of being fully human — compassion and generosity. A fundamental concept in West Africa.",
      example: "A bɛ mɔgɔya sɔrɔ. (Il/Elle est gentil(le) / Il/Elle a de l'humanité.)",
      exampleEn: "A bɛ mɔgɔya sɔrɔ. (He/She is kind / He/She has humanity.)"
    },
  },

  'Adjectifs — États et émotions': {
    'Here': {
      translation: "Heureux, content",
      translationEn: "Happy, glad",
      explanation: "État émotionnel positif.",
      explanationEn: "Positive emotional state.",
      example: "A here ye. (Il/Elle est heureux/heureuse.)",
      exampleEn: "A here ye. (He/She is happy.)"
    },
    'Bangebɛ': {
      translation: "Triste",
      translationEn: "Sad",
      explanation: "État émotionnel négatif.",
      explanationEn: "Negative emotional state.",
      example: "A bangebɛ ye. (Il/Elle est triste.)",
      exampleEn: "A bangebɛ ye. (He/She is sad.)"
    },
    'Bumɛn': {
      translation: "Fort, solide",
      translationEn: "Strong, sturdy",
      explanation: "Force physique ou morale.",
      explanationEn: "Physical or moral strength.",
      example: "A ka muso bumɛn ye. (Sa femme est forte.)",
      exampleEn: "A ka muso bumɛn ye. (His wife is strong.)"
    },
    'Zɛrɛ': {
      translation: "Faible, fragile",
      translationEn: "Weak, fragile",
      explanation: "Faiblesse physique ou morale.",
      explanationEn: "Physical or moral weakness.",
      example: "A zɛrɛ ye sisan. (Il/Elle est faible en ce moment.)",
      exampleEn: "A zɛrɛ ye sisan. (He/She is weak right now.)"
    },
    'Hakili jɛ': {
      translation: "Intelligent, à l'esprit vif",
      translationEn: "Intelligent, sharp-minded",
      explanation: "'Hakili' = esprit/intelligence + 'jɛ' = propre/clair. Littéralement 'l'esprit clair'.",
      explanationEn: "'Hakili' = mind/intelligence + 'jɛ' = clean/clear. Literally 'the clear mind'.",
      example: "A ka hakili jɛ ye. (Il/Elle a l'esprit vif.)",
      exampleEn: "A ka hakili jɛ ye. (He/She is sharp-minded.)"
    },
    'Hakili jan': {
      translation: "Patient, posé",
      translationEn: "Patient, composed",
      explanation: "'Jan' = long/étendu. Littéralement 'l'esprit long' = la patience.",
      explanationEn: "'Jan' = long/extended. Literally 'the long mind' = patience.",
      example: "A ka hakili jan ye. (Il/Elle est patient(e).)",
      exampleEn: "A ka hakili jan ye. (He/She is patient.)"
    },
    'Kɔrɔn': {
      translation: "Vieux, âgé",
      translationEn: "Old, elderly",
      explanation: "Décrit l'âge avancé ou l'ancienneté. Note : les personnes âgées sont très respectées en bambara.",
      explanationEn: "Describes advanced age or seniority. Note: elderly people are highly respected in Bambara culture.",
      example: "A ka baba kɔrɔn ye. (Son père est vieux.)",
      exampleEn: "A ka baba kɔrɔn ye. (His/Her father is old.)"
    },
    'Bana': {
      translation: "Malade",
      translationEn: "Sick",
      explanation: "État de maladie.",
      explanationEn: "State of illness.",
      example: "A bana ye. (Il/Elle est malade.)",
      exampleEn: "A bana ye. (He/She is sick.)"
    },
  },

  'Adjectifs — Goût et sensations': {
    'Di': {
      translation: "Bon (au goût), agréable",
      translationEn: "Good (in taste), pleasant",
      explanation: "'Di' qualifie ce qui est agréable au goût ou à l'expérience sensorielle.",
      explanationEn: "'Di' qualifies what is pleasant in taste or sensory experience.",
      example: "Nin dumuni di ye. (Ce plat est bon.)",
      exampleEn: "Nin dumuni di ye. (This dish is good.)",
      audio: "Ba-di"
    },
    'Bilen': {
      translation: "Sucré",
      translationEn: "Sweet",
      explanation: "Goût sucré.",
      explanationEn: "Sweet taste.",
      example: "Nin tɔ bilen ye. (Cette boisson est sucrée.)",
      exampleEn: "Nin tɔ bilen ye. (This drink is sweet.)"
    },
    'Kɛrɛ': {
      translation: "Amer",
      translationEn: "Bitter",
      explanation: "Goût amer.",
      explanationEn: "Bitter taste.",
      example: "Ji nin kɛrɛ ye. (Cette eau est amère.)",
      exampleEn: "Ji nin kɛrɛ ye. (This water is bitter.)"
    },
    'Kalan': {
      translation: "Salé",
      translationEn: "Salty",
      explanation: "Goût salé.",
      explanationEn: "Salty taste.",
      example: "Dumuni nin kalan ye. (Ce plat est trop salé.)",
      exampleEn: "Dumuni nin kalan ye. (This dish is too salty.)"
    },
    'Nyimi': {
      translation: "Douloureux",
      translationEn: "Painful",
      explanation: "Cause une douleur physique.",
      explanationEn: "Causes physical pain.",
      example: "N ka kɔrɔ nyimi ye. (Ma jambe fait mal.)",
      exampleEn: "N ka kɔrɔ nyimi ye. (My leg hurts.)"
    },
    'Sɔgɔma': {
      translation: "Propre, net",
      translationEn: "Clean, tidy",
      explanation: "Décrit la propreté d'un lieu ou d'un objet.",
      explanationEn: "Describes the cleanliness of a place or object.",
      example: "A ka dan sɔgɔma ye. (Sa chambre est propre.)",
      exampleEn: "A ka dan sɔgɔma ye. (His/Her room is clean.)",
      audio: "Ba-sogoma"
    },
    'Saaji': {
      translation: "Sale",
      translationEn: "Dirty",
      explanation: "Opposé de 'sɔgɔma'.",
      explanationEn: "Opposite of 'sɔgɔma'.",
      example: "A ka kosɛbɛ saaji ye. (Ses vêtements sont sales.)",
      exampleEn: "A ka kosɛbɛ saaji ye. (His/Her clothes are dirty.)"
    },
    'Gɛrɛ': {
      translation: "Difficile, dur",
      translationEn: "Difficult, hard",
      explanation: "Décrit une difficulté ou une dureté.",
      explanationEn: "Describes a difficulty or hardness.",
      example: "A ka kalan gɛrɛ ye. (Sa leçon est difficile.)",
      exampleEn: "A ka kalan gɛrɛ ye. (His/Her lesson is difficult.)"
    },
  },

  'Adjectifs — Quantité et valeur': {
    'Camman': {
      translation: "Beaucoup, nombreux",
      translationEn: "Many, numerous",
      explanation: "Décrit une grande quantité.",
      explanationEn: "Describes a large quantity.",
      example: "Mɔgɔ camman bɛ yan. (Il y a beaucoup de monde ici.)",
      exampleEn: "Mɔgɔ camman bɛ yan. (There are many people here.)"
    },
    'Dɔɔnin': {
      translation: "Peu, un peu",
      translationEn: "A little, a few",
      explanation: "Décrit une petite quantité.",
      explanationEn: "Describes a small quantity.",
      example: "Ji dɔɔnin bɛ yan. (Il y a peu d'eau ici.)",
      exampleEn: "Ji dɔɔnin bɛ yan. (There is little water here.)"
    },
    'Cogoyɛ': {
      translation: "Facile, simple",
      translationEn: "Easy, simple",
      explanation: "Décrit quelque chose de simple à réaliser.",
      explanationEn: "Describes something simple to do.",
      example: "A ka nɔgɔ cogoyɛ ye. (Son travail est facile.)",
      exampleEn: "A ka nɔgɔ cogoyɛ ye. (His/Her work is easy.)"
    },
    'Nafolo': {
      translation: "Riche",
      translationEn: "Rich",
      explanation: "Possède beaucoup de biens matériels.",
      explanationEn: "Possesses many material goods.",
      example: "A nafolo ye. (Il/Elle est riche.)",
      exampleEn: "A nafolo ye. (He/She is rich.)",
      audio: "Ba-nafolo"
    },
    'Fantan': {
      translation: "Pauvre",
      translationEn: "Poor",
      explanation: "Manque de ressources matérielles.",
      explanationEn: "Lacks material resources.",
      example: "A fantan ye. (Il/Elle est pauvre.)",
      exampleEn: "A fantan ye. (He/She is poor.)"
    },
    'Bonya': {
      translation: "Respecté, honorable",
      translationEn: "Respected, honorable",
      explanation: "Grande valeur sociale positive — être respecté par la communauté.",
      explanationEn: "High positive social value — being respected by the community.",
      example: "A bonya ye. (Il/Elle est respecté(e).)",
      exampleEn: "A bonya ye. (He/She is respected.)"
    },
    'Kɛnɛya': {
      translation: "En bonne santé",
      translationEn: "In good health",
      explanation: "État de santé positif — nom abstrait utilisé avec 'sɔrɔ' (obtenir/avoir).",
      explanationEn: "Positive state of health — abstract noun used with 'sɔrɔ' (to obtain/have).",
      example: "A bɛ kɛnɛya sɔrɔ. (Il/Elle est en bonne santé.)",
      exampleEn: "A bɛ kɛnɛya sɔrɔ. (He/She is in good health.)"
    },
    'Tigiya': {
      translation: "Important, de valeur",
      translationEn: "Important, valuable",
      explanation: "Importance sociale ou morale.",
      explanationEn: "Social or moral importance.",
      example: "A ka kalan bɛ tigiya sɔrɔ. (Sa leçon est importante.)",
      exampleEn: "A ka kalan bɛ tigiya sɔrɔ. (His/Her lesson is important.)"
    },
  },

  'Conjonctions': {
    'Ni': {
      translation: "Et / Avec",
      translationEn: "And / With",
      explanation: "'Ni' relie deux noms ou éléments de même nature. Équivalent de 'et/avec' entre deux noms.",
      explanationEn: "'Ni' links two nouns or elements of the same nature. Equivalent to 'and/with' between two nouns.",
      example: "Moussa ni Fatoumata bɛ yan. (Moussa et Fatoumata sont ici.)",
      exampleEn: "Moussa ni Fatoumata bɛ yan. (Moussa and Fatoumata are here.)"
    },
    'Nka': {
      translation: "Mais",
      translationEn: "But",
      explanation: "'Nka' introduit une opposition ou une restriction.",
      explanationEn: "'Nka' introduces an opposition or a restriction.",
      example: "N bɛ bɔ, nka n tɛ mɛn. (Je pars, mais je ne me sens pas bien.)",
      exampleEn: "N bɛ bɔ, nka n tɛ mɛn. (I am leaving, but I don't feel well.)"
    },
    'Bari': {
      translation: "Parce que, car",
      translationEn: "Because",
      explanation: "'Bari' introduit la cause d'une action ou d'un état.",
      explanationEn: "'Bari' introduces the cause of an action or a state.",
      example: "N ma taa bari sisan tɛ. (Je ne suis pas parti(e) parce que ce n'est pas l'heure.)",
      exampleEn: "N ma taa bari sisan tɛ. (I did not leave because it is not yet time.)"
    },
    'Ko': {
      translation: "Que (discours indirect)",
      translationEn: "That (reported speech)",
      explanation: "'Ko' introduit un discours rapporté ou une proposition complétive.",
      explanationEn: "'Ko' introduces reported speech or a complement clause.",
      example: "A y'a fɔ ko a bɛna naa. (Il/Elle a dit qu'il/elle viendrait.)",
      exampleEn: "A y'a fɔ ko a bɛna naa. (He/She said that he/she would come.)"
    },
    'Walima': {
      translation: "Ou bien",
      translationEn: "Or",
      explanation: "'Walima' marque une alternative ou un choix entre deux éléments.",
      explanationEn: "'Walima' marks an alternative or a choice between two elements.",
      example: "I bɛ bɔ walima i bɛ sigi? (Tu pars ou tu restes ?)",
      exampleEn: "I bɛ bɔ walima i bɛ sigi? (Are you leaving or staying?)"
    },
    'Hali': {
      translation: "Même si / Bien que",
      translationEn: "Even if / Although",
      explanation: "'Hali' exprime la concession — la proposition principale est vraie malgré la subordonnée.",
      explanationEn: "'Hali' expresses concession — the main clause is true despite the subordinate clause.",
      example: "Hali a taara, a ma n wele. (Même s'il est parti, il ne m'a pas appelé.)",
      exampleEn: "Hali a taara, a ma n wele. (Even though he left, he did not call me.)"
    },
    'Ni...bɛ': {
      translation: "Si... (conditionnel)",
      translationEn: "If... (conditional)",
      explanation: "'Ni' en tête de proposition + 'bɛ' introduit une condition hypothétique.",
      explanationEn: "'Ni' at the head of the clause + 'bɛ' introduces a hypothetical condition.",
      example: "Ni i bɛ sɔrɔla, wele n. (Si tu es disponible, appelle-moi.)",
      exampleEn: "Ni i bɛ sɔrɔla, wele n. (If you are available, call me.)"
    },
    'Ka kɔ': {
      translation: "Ensuite / Puis",
      translationEn: "Then / Next",
      explanation: "Marqueur de séquence temporelle — indique ce qui vient après.",
      explanationEn: "Temporal sequence marker — indicates what comes next.",
      example: "Fɔlɔ i ka kalan, ka kɔ i ka taa. (D'abord étudie, ensuite tu pars.)",
      exampleEn: "Fɔlɔ i ka kalan, ka kɔ i ka taa. (First study, then you leave.)",
      audio: "Ba-ka_ko"
    },
  },

  'Adverbes': {
    'Sisan': {
      translation: "Maintenant, à présent",
      translationEn: "Now, at present",
      explanation: "Adverbe de temps situant l'action dans le moment présent.",
      explanationEn: "Adverb of time placing the action in the present moment.",
      example: "Sisan n bɛ kalan. (Maintenant j'étudie.)",
      exampleEn: "Sisan n bɛ kalan. (Now I am studying.)",
      audio: "Ba-sisan"
    },
    'Kunun': {
      translation: "Hier",
      translationEn: "Yesterday",
      explanation: "Adverbe de temps désignant le jour précédent.",
      explanationEn: "Adverb of time designating the previous day.",
      example: "A taara duguma kunun. (Il/Elle est allé(e) en ville hier.)",
      exampleEn: "A taara duguma kunun. (He/She went to town yesterday.)"
    },
    'Sini': {
      translation: "Demain",
      translationEn: "Tomorrow",
      explanation: "Adverbe de temps désignant le jour suivant.",
      explanationEn: "Adverb of time designating the following day.",
      example: "N bɛna taa sini. (J'irai demain.)",
      exampleEn: "N bɛna taa sini. (I will go tomorrow.)",
      audio: "Ba-sini"
    },
    'Tile': {
      translation: "Aujourd'hui / Ce jour",
      translationEn: "Today / This day",
      explanation: "Adverbe de temps désignant la journée en cours.",
      explanationEn: "Adverb of time designating the current day.",
      example: "Tile n bɛ here. (Aujourd'hui je suis content(e).)",
      exampleEn: "Tile n bɛ here. (Today I am happy.)",
      audio: "Ba-tile"
    },
    'Fɔlɔ': {
      translation: "D'abord, en premier",
      translationEn: "First, at first",
      explanation: "Marqueur d'ordre dans une séquence d'actions.",
      explanationEn: "Order marker in a sequence of actions.",
      example: "Fɔlɔ i ka dumuni kɛ. (D'abord, fais la cuisine.)",
      exampleEn: "Fɔlɔ i ka dumuni kɛ. (First, cook the meal.)"
    },
    'Tuma bɛɛ': {
      translation: "Toujours, tout le temps",
      translationEn: "Always, all the time",
      explanation: "'Tuma' = temps/moment + 'bɛɛ' = tout. Exprime la permanence ou l'habitude constante.",
      explanationEn: "'Tuma' = time/moment + 'bɛɛ' = all. Expresses permanence or a constant habit.",
      example: "A tuma bɛɛ bɛ naa. (Il/Elle vient toujours.)",
      exampleEn: "A tuma bɛɛ bɛ naa. (He/She always comes.)"
    },
    'Dɔɔnin dɔɔnin': {
      translation: "Peu à peu, doucement",
      translationEn: "Little by little, gently",
      explanation: "Adverbe de manière exprimant la progressivité ou la lenteur — équivalent de 'ndank ndank' en wolof.",
      explanationEn: "Adverb of manner expressing gradualness or slowness — equivalent to 'ndank ndank' in Wolof.",
      example: "Kalan dɔɔnin dɔɔnin. (Apprends peu à peu.)",
      exampleEn: "Kalan dɔɔnin dɔɔnin. (Learn little by little.)"
    },
    'Ka ca': {
      translation: "Trop, excessivement",
      translationEn: "Too much, excessively",
      explanation: "Exprime un excès — se place après le verbe ou l'adjectif.",
      explanationEn: "Expresses excess — placed after the verb or adjective.",
      example: "A bɛ kuma ka ca. (Il/Elle parle trop.)",
      exampleEn: "A bɛ kuma ka ca. (He/She talks too much.)"
    },
    'Kosɛbɛ': {
      translation: "Vraiment, très, beaucoup",
      translationEn: "Really, very, a lot",
      explanation: "Intensificateur très courant en bambara, plus fort que 'camman'.",
      explanationEn: "A very common intensifier in Bambara, stronger than 'camman'.",
      example: "A dɔɔrɔman kosɛbɛ ye. (Il/Elle est vraiment beau/belle.)",
      exampleEn: "A dɔɔrɔman kosɛbɛ ye. (He/She is really beautiful.)"
    },
  },

};

export default grammaire;
export {};
